import type { CrossFlowContextType } from '@atlassiansox/cross-flow-api-internals';
import { Journeys, Targets } from '@atlassiansox/cross-flow-support';
import type { UIAnalyticsEvent, AnalyticsEventPayload } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';

type Props = {
	createAnalyticsEvent: (_payload: AnalyticsEventPayload) => UIAnalyticsEvent;
	crossFlowEligible: boolean;
	crossflow: CrossFlowContextType;
	projectId: number | undefined;
	projectName: string | undefined;
	component: string;
	context: string;
	coUseEligible: boolean;
	url: string;
};

export const onClickCTA = ({
	createAnalyticsEvent,
	crossFlowEligible,
	crossflow,
	projectId,
	projectName,
	component,
	context,
	coUseEligible,
	url,
}: Props) => {
	if (crossFlowEligible) {
		if (!crossflow.isEnabled) {
			return;
		}
		if (!!projectId && !!projectName) {
			crossflow.api.open({
				sourceComponent: component,
				sourceContext: context,
				targetProduct: Targets.CONFLUENCE,
				journey: Journeys.GET_STARTED,
				experimentalOptions: {
					projectId,
					projectName,
				},
			});
		} else {
			fireTrackAnalytics(createAnalyticsEvent({}), 'projectInfo missing', {
				isCrossFlowEligible: crossFlowEligible,
				isCoUseEligible: coUseEligible,
				projectId,
				projectName,
			});
		}
	} else if (coUseEligible) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.open(url, '_blank');
	}
};
